import basicBreather1 from 'assets/images/basic-breather1.png';
import basicBreather2 from 'assets/images/basic-breather2.png';
import basicBreather3 from 'assets/images/basic-breather3.png';

import bigSneeze1 from 'assets/images/big-sneeze1.png';
import bigSneeze2 from 'assets/images/big-sneeze2.png';
import bigSneeze4 from 'assets/images/big-sneeze4.png';
import bigSneeze5 from 'assets/images/big-sneeze5.png';

import homeWrecker1 from 'assets/images/home-wrecker1.png';
import homeWrecker2 from 'assets/images/home-wrecker2.png';
import homeWrecker3 from 'assets/images/home-wrecker3.png';
import homeWrecker4 from 'assets/images/home-wrecker4.png';
import homeWrecker5 from 'assets/images/home-wrecker5.png';

import overreactor1 from 'assets/images/overreactor1.png';
import overreactor2 from 'assets/images/overreactor2.png';
import overreactor3 from 'assets/images/overreactor3.png';
import overreactor4 from 'assets/images/overreactor4.png';
import overreactor5 from 'assets/images/overreactor5.png';

import critterCuddler1 from 'assets/images/critter-cuddler1.png';
import critterCuddler2 from 'assets/images/critter-cuddler2.png';
import critterCuddler3 from 'assets/images/critter-cuddler3.png';

import mamaRoom1 from 'assets/images/mama-room1.png';
import mamaRoom2 from 'assets/images/mama-room2.png';
import mamaRoom3 from 'assets/images/mama-room3.png';
import mamaRoom4 from 'assets/images/mama-room4.png';

import rookieParent1 from 'assets/images/rookie-parent1.png';
import rookieParent2 from 'assets/images/rookie-parent2.png';
import rookieParent4 from 'assets/images/rookie-parent4.png';

import peacekeeper1 from 'assets/images/peacekeeper-1.png';
import peacekeeper2 from 'assets/images/peacekeeper-2.png';
import peacekeeper3 from 'assets/images/peacekeeper-3.png';
import peacekeeper4 from 'assets/images/peacekeeper-4.png';
import peacekeeper5 from 'assets/images/peacekeeper-5.png';

/**
 * @type {{ BB: {sliderImages: [{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number}, {src, alt: string, box: number, target: number}], sliderItems: [{text: string, title: string},{text: string, title: string},{text: string, title: string}], type: string}, CC: {sliderImages: [{src, alt: string, box: number, target: number}, {src, alt: string, box: number, target: number}, {src, alt: string, box: number, target: number}],
 * sliderItems: [{text: string, title: string}, {text: string, title: string}, {text: string, title: string}], type: string}, BS: {sliderImages: [{src, alt: string, box: number, target: number}, {src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number}],sliderItems: [{text: string, title: string}, {text: string, title: string}, {text: string, title: string}, {text: string, title: string}],  type: string}, OR: {sliderImages: [{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number}, {src, alt: string, box: number, target: number}, {src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number}], sliderItems: [{text: string, title: string}, {text: string, title: string}, {text: string, title: string}, {text: string, title: string},{text: string, title: string}], type: string}, PC: {sliderImages: [{src, alt: string, box: number, target: number}, {src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number}, {src, alt: string, box: number, target: number}, {src, alt: string, box: number, target: number}],sliderItems: [{text: string, title: string}, {text: string, title: string},{text: string, title: string},{text: string, title: string},{text: string, title: string}], type: string}, MB: {sliderImages: [{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number}], sliderItems: [{text: string, title: string},{text: string, title: string},{text: string, title: string},{text: string, title: string}], type: string}, RP: {sliderImages: [{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number}], sliderItems: [{text: string, title: string},{text: string, title: string},{text: string, title: string}], type: string}, HW: {sliderImages: [{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number},{src, alt: string, box: number, target: number}], sliderItems: [{text: string, title: string},{text: string, title: string},{text: string, title: string},{text: string, title: string},{text: string, title: string}], type: string}}}
 */
const filterFeatureStatic = {
  BB: {
    type: 'Basic Breather',
    sliderImages: [
      {
        src: basicBreather1, alt: 'basic-breather', target: 0, box: 1,
      },
      {
        src: basicBreather2, alt: 'basic-breather', target: 1, box: 2,
      },
      {
        src: basicBreather3, alt: 'basic-breather', target: 2, box: 3,
      },
    ],
    sliderItems: [
      {
        title: 'Outdoor pollution',
        text: 'You can’t see fine particles wafting in from nearby roads, construction sites, '
          + 'or industrial buildings, but they’re in your air—and they’re harmful. '
          + 'PM can trigger a range of respiratory symptoms and even more serious conditions like heart attacks.',
      },
      {
        title: 'Indoor particulates',
        text: 'Did you know that even just frying up some bacon in your house can create unhealthy '
          + 'levels of PM in your home? If you cook or burn other fuel sources indoors, '
          + 'you’re susceptible to these irritating particles.',
      },
      {
        title: 'House dust',
        text: 'That lovely film that manages to settle on everything in your house is a mix of dead skin, '
          + 'upholstery and carpet fibers, and soil tracked in from outside. '
          + 'Even if you aren’t allergic to dust, do you really want to be inhaling it?',
      },
    ],
  },
  BS: {
    type: 'Big Sneeze',
    sliderImages: [
      {
        src: bigSneeze1, alt: 'big-sneeze1', target: 0, box: 1,
      },
      {
        src: bigSneeze2, alt: 'big-sneeze2', target: 1, box: 2,
      },
      {
        src: bigSneeze4, alt: 'big-sneeze4', target: 2, box: 4,
      },
      {
        src: bigSneeze5, alt: 'big-sneeze5', target: 3, box: 5,
      },
    ],
    sliderItems: [
      {
        title: 'Pollen',
        text: 'This common allergen can enter your home through open doors and windows, '
          + 'or come in on your clothing or shoes. Once inside, pollen grains can remain '
          + 'airborne or settle on surfaces, where they lie in wait until you disturb them again.',
      },
      {
        title: 'House dust',
        text: 'In spite of your best efforts to clean, your home will accumulate '
          + 'dust over time. House dust is a delightful mix of sloughed-off skin cells, '
          + 'hair, clothing fibers, bacteria, dust mites, bits of dead bugs, soil particles, '
          + 'pollen, and microscopic specks of plastic.',
      },
      {
        title: 'Dander',
        text: 'Dander is microscopic flecks of skin shed from the body of humans and pets.🤢 '
          + 'It can linger in the air quite a while before contributing to house dust, '
          + 'accumulating on surfaces and carpets.',
      },
      {
        title: 'Superfine particulates',
        text: 'Yes, even pollution can trigger your need to sneeze. Studies show that '
          + 'particulate matter, which comes from nearby roads, industrial buildings, or even your own '
          + 'cooking, can interact with airborne allergens and worsen your symptoms.',
      },
    ],
  },
  CC: {
    type: 'Critter Cuddler',
    sliderImages: [
      {
        src: critterCuddler1, alt: 'basic-breather', target: 0, box: 1,
      },
      {
        src: critterCuddler2, alt: 'basic-breather', target: 1, box: 2,
      },
      {
        src: critterCuddler3, alt: 'basic-breather', target: 2, box: 3,
      },
    ],
    sliderItems: [
      {
        title: 'Pet dander',
        text: 'While your pet’s lazing about the house, they’re shedding dander—tiny '
          + 'flecks of skin—all over the place. Dander often causes allergic reactions in humans, '
          + 'and it can linger for a long, long time on furniture and carpet.',
      },
      {
        title: 'Smelly odors',
        text: 'We love our pets, but they sure can raise a stink. '
          + 'Especially cats, who relieve themselves indoors. Cat smell comes primarily '
          + 'from the ammonia generated from decomposing urine in the litter box. 🙀',
      },
      {
        title: 'Pet hair',
        text: 'Contrary to popular belief, pet hair itself isn’t an allergen. '
          + 'But it can carry allergenic substances like pet dander, urine, '
          + 'and saliva, as well as dust and pollen. Oh, Fido.',
      },
    ],
  },
  HW: {
    type: 'Home Wrecker',
    sliderImages: [
      {
        src: homeWrecker1, alt: 'home-wrecker1', target: 0, box: 1,
      },
      {
        src: homeWrecker2, alt: 'home-wrecker2', target: 1, box: 2,
      },
      {
        src: homeWrecker3, alt: 'home-wrecker3', target: 2, box: 3,
      },
      {
        src: homeWrecker4, alt: 'home-wrecker4', target: 3, box: 4,
      },
      {
        src: homeWrecker5, alt: 'home-wrecker5', target: 4, box: 5,
      },
    ],
    sliderItems: [
      {
        title: 'New Carpet Smell',
        text: 'The scent is actually chemical off-gassing from materials in the carpet’s backing, '
          + 'padding, and adhesives. They can irritate your airways, make you nauseous, '
          + 'and even lead to breathing problems in babies.',
      },
      {
        title: 'New Paint Smell',
        text: 'What you’re sniffing is off-gassing benzene, a volatile organic compound (VOC) '
          + 'which has been linked to a number of health problems including '
          + 'headaches (short term) and cancer (long term).',
      },
      {
        title: 'New Furniture Smell',
        text: 'The culprit here is formaldehyde, a gas used in furniture adhesives and coatings. '
          + 'It can irritate the eyes, nose, and throat, and may even cause cancer.',
      },
      {
        title: 'Wood Floor Smell',
        text: 'New wood flooring (particularly engineered wood and laminate) '
          + 'can emit formaldehyde, a known irritant and carcinogen.',
      },
      {
        title: 'Construction Dust',
        text: 'Ripping up the old and installing the new can kick up a lot of dust and debris, '
          + 'irritating airways and worsening underlying health conditions.',
      },
    ],
  },
  MB: {
    type: 'Mama-to-Be',
    sliderImages: [
      {
        src: mamaRoom1, alt: 'mama-room', target: 0, box: 1,
      },
      {
        src: mamaRoom2, alt: 'mama-room', target: 1, box: 2,
      },
      {
        src: mamaRoom3, alt: 'mama-room', target: 2, box: 3,
      },
      {
        src: mamaRoom4, alt: 'mama-room', target: 3, box: 4,
      },
    ],
    sliderItems: [
      {
        title: 'Superfine particulates',
        text: 'Pollution particles from nearby roads, industrial buildings, '
          + 'or even your own cooking can cause high blood pressure, gestational '
          + 'diabetes or pre-eclampsia. Studies also show risks of low birth weight, '
          + 'preterm births, infant asthma, and developmental problems.',
      },
      {
        title: 'VOCs',
        text: 'Volatile organic compounds (VOCs) emitted from household products, '
          + 'new furniture, or fresh nursery paint can slow baby’s growth, cause premature birth, '
          + 'and increase the child’s risk of developing health conditions later in life.',
      },
      {
        title: 'Viruses and bacteria',
        text: 'Pregnancy creates changes in the immune system that can '
          + 'affect a woman’s response to pathogens. To avoid any risks to '
          + 'baby, mamas should do everything they can to avoid contact '
          + 'with viruses and bacteria.',
      },
      {
        title: 'Unpleasant odors',
        text: 'Odor triggers from meat to cleaning products can '
          + 'lead to hours spent hovering over the porcelain throne. 🤢',
      },
    ],
  },
  OR: {
    type: 'Overreactor',
    sliderImages: [
      {
        src: overreactor1, alt: 'overreactor', target: 0, box: 1,
      },
      {
        src: overreactor2, alt: 'overreactor', target: 1, box: 2,
      },
      {
        src: overreactor3, alt: 'overreactor', target: 2, box: 3,
      },
      {
        src: overreactor4, alt: 'overreactor', target: 3, box: 4,
      },
      {
        src: overreactor5, alt: 'overreactor', target: 4, box: 5,
      },
    ],
    sliderItems: [
      {
        title: 'Outdoor pollution',
        text: 'You can’t see fine particles wafting in from nearby roads, '
          + 'construction sites, or industrial buildings, but they’re in your air—and they’re harmful. '
          + 'PM can trigger a range of respiratory symptoms and even more serious conditions like heart attacks.',
      },
      {
        title: 'Indoor particulates',
        text: 'Did you know that even just frying up some bacon in your house can create '
          + 'unhealthy levels of PM in your home? If you cook or burn other fuel sources indoors, '
          + 'you’re susceptible to these irritating particles.',
      },
      {
        title: 'Germs',
        text: 'Contrary to popular belief, pet hair itself isn’t an allergen. But it '
          + 'can carry allergenic substances like pet dander, urine, and '
          + 'saliva, as well as dust and pollen. Oh, Fido.',
      },
      {
        title: 'Odors',
        text: 'Air isn’t fresh if it’s loaded with stinky smells from pets, bathrooms, or last night’s sautéed salmon.',
      },
      {
        title: 'VOCs',
        text: 'Volatile organic compounds (VOCs) emitted from household products, new furniture, '
          + 'or fresh paint are worthy of your worry. They can cause short-term symptoms such as '
          + 'respiratory tract irritation, headaches, and dizziness. Long-term exposure can even cause cancer and liver damage.',
      },
    ],
  },
  RP: {
    type: 'Rookie Parent',
    sliderImages: [
      {
        src: rookieParent1, alt: 'rookie-parent1', target: 0, box: 1,
      },
      {
        src: rookieParent4, alt: 'rookie-parent3', target: 1, box: 2,
      },
      {
        src: rookieParent2, alt: 'rookie-parent2', target: 2, box: 4,
      },
    ],
    sliderItems: [
      {
        title: 'Superfine particulates',
        text: 'Children under 10 are more susceptible to the health effects of '
          + 'particulate matter (PM) than adults. Pollution particles from nearby roads, '
          + 'industrial buildings, or even your own cooking can cause wheezing, poor lung '
          + 'function, and exacerbated asthma in kids.',
      },
      {
        title: 'VOCs',
        text: 'Volatile organic compounds (VOCs) emitted from household products, '
          + 'new furniture, or fresh nursery paint can cause short-term symptoms such '
          + 'as eye and respiratory tract irritation, headaches, and dizziness. Long-term '
          + 'exposure can even cause cancer and liver damage.',
      },
      {
        title: 'Unpleasant odors',
        text: 'Those dirty diapers can add up quickly—and so can their stank.',
      },
    ],
  },
  PC: {
    type: 'Peacekeeper',
    sliderImages: [
      {
        src: peacekeeper1, alt: 'peacekeeper', target: 0, box: 1,
      },
      {
        src: peacekeeper2, alt: 'peacekeeper', target: 1, box: 2,
      },
      {
        src: peacekeeper3, alt: 'peacekeeper', target: 2, box: 3,
      },
      {
        src: peacekeeper4, alt: 'peacekeeper', target: 3, box: 4,
      },
      {
        src: peacekeeper5, alt: 'peacekeeper', target: 4, box: 5,
      },
    ],
    sliderItems: [
      {
        title: 'Passive Aggression',
        text: 'Also known as PA2.5, this common home air issue arises from snarky and anonymous notes left around the house intended to make you feel like an idiot. Like the one taped to the thermostat that yells, “DO NOT TOUCH’ and suggests you “PUT ON A SWEATER.” Studies show PA may also be found in the silent treatment.',
      },
      {
        title: 'Negativity',
        text: 'A blanket term for the emission of critical, pessimistic, and cynical particulates that all air breathers give off from time to time. You’ll know it’s reached unhealthy levels when the mood in the room is about as fun as a quarantine zone in The Last of Us.',
      },
      {
        title: 'Blame',
        text: 'This toxic airborne compound accumulates when everything is everybody else’s fault, like how the crumbs on the kitchen counter always get pinned on you. Even a whiff of blame is enough to irritate anyone’s airways.',
      },
      {
        title: 'Drama',
        text: 'Little things that are made out to be a giant crisis, like when somebody loses their mind because you’ve run out of bread—even though there is other bread but it’s not the GOOD KIND of bread—emit drama in the home. Drama has a strong odor and often triggers an allergic reaction to the drama producer.',
      },
      {
        title: 'Tension',
        text: 'Found in most homes, tension is caused by a wide range of activity such as the off-gassing of teenage hormones, having adorable pets that make you sneeze, trying to build an IKEA bookshelf, etc. You’ll know it’s present when it feels like you could cut the air with a knife—like, actually.',
      },
    ],
  },
};

export default filterFeatureStatic;
